<template>
  <div>
    <b-row class="mb-3">
      <b-col>
        <botonsolicitud />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <listaBajaCA />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import listaBajaCA from '@/views/campus/control-academico/bajas/components/lista-solicitud-baja.vue'
import {
  BRow, BCol,

} from 'bootstrap-vue'

const botonsolicitud = () => import('@/views/campus/control-academico/bajas/components/botonparaalumno.vue')

export default {
  components: {
    listaBajaCA,
    botonsolicitud,
    BRow,
    BCol,
  },
}
</script>
